import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CustomValidators } from 'src/utils/custom-validators/custom-validators';

@UntilDestroy()
@Component({
    selector: 'ca-med-edit-studyid-dialog',
    templateUrl: './MED-edit-study-ID-dialog.component.html',
    styleUrls: ['./MED-edit-study-ID-dialog.component.scss'],
})
export class MEDEditStudyIDDialogComponent implements OnInit {
    @Input() title: string;
    @Input() inputLabel: string;
    @Input() confirmText: string;
    @Input() cancelText: string;
    @Input() selectedFiles: string;
    @Input() selectedFileIDs: string[];
    @Input() placeholder: string;
    @Input() titleKey: string;
    @Input() hasStudyID: boolean;

    @Output() applyStudyIdEvent: EventEmitter<{ studyId: string; fileIDs: string[] }> = new EventEmitter<{
        studyId: string;
        fileIDs: string[];
    }>();

    formGroup: UntypedFormGroup;
    isTyping = false;
    tags: string[] = [];
    showIcons = false;

    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
    ) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            value: ['', [Validators.required, CustomValidators.NotContainingOnlyWhitespaces()]],
        });
    }

    close(): void {
        this.activeModal.close();
    }

    dismiss(): void {
        this.activeModal.dismiss('canceled');
    }

    submit(): void {
        this.applyStudyIdEvent.emit({ studyId: this.formGroup.value.value.trim(), fileIDs: this.selectedFileIDs });
        this.activeModal.close();
    }

    enableSubmitButton(): boolean {
        return this.tags.length > 0;
    }

    onInputChange(): void {
        if (this.formGroup.value.value.trim() !== '') {
            this.isTyping = true;
        } else {
            this.isTyping = false;
        }
    }

    onResetInput(): void {
        this.formGroup.get('value')?.setValue('');
    }
}
